import { Eye, X } from "lucide-react";
import { exitPreview } from "@/hooks/useLayout";

/* Bottom-left pill so it never covers the site header, nav or chat launchers. */
export const LayoutPreviewBanner = () => (
  <div data-testid="layout-preview-banner" className="fixed bottom-4 left-4 z-[95] max-w-[calc(100vw-2rem)] flex flex-wrap items-center gap-2 rounded-2xl bg-[#B57E17] text-white text-xs sm:text-sm font-medium px-4 py-2.5 shadow-[0_12px_32px_rgba(0,0,0,0.25)]">
    <Eye size={14} className="shrink-0" /> <span>Previewing the <b>draft</b> page layout — participants still see the published version.</span>
    <button type="button" data-testid="layout-preview-exit" onClick={exitPreview} className="inline-flex items-center gap-1 rounded-full bg-white/20 hover:bg-white/30 px-3 py-1"><X size={12} /> Exit preview</button>
  </div>
);
